import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const usersApi = createApi({
    reducerPath: "users",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['users'],
    endpoints: (builder) => ({
        getUser: builder.query({
            query: ({page,limit,time_range,search,status}) => ({
                url: `admin/users?page=${page+1}&limit=${limit}&search=${search}&status=${status}&time_range=${time_range}`,
                method: "GET",
            }),
            transformResponse: (res) => res,
            providesTags: ['users'],
        }), 
        updateUserStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `admin/user/status/${id}?status=${status}`,
                method: 'PUT',
            }),
            invalidatesTags: ['users'],
        }),
         updateUserType: builder.mutation({
            query: ({ id, userType }) => ({
                url: `admin/user/user_type/${id}?user_type=${userType}`,
                method: 'PUT',
            }),
            invalidatesTags: ['users'],
        }),

    })
});

export const { useGetUserQuery, useUpdateUserStatusMutation, useUpdateUserTypeMutation } = usersApi;